import React from "react";

const DashBoardProductsDetails = () => {
  return (
    <div>
      <h1>hello dashboard products details</h1>
    </div>
  );
};

export default DashBoardProductsDetails;
